package pl.decks.chartjs.mode

import pl.decks.chartjs.model.JSEnum

@Suppress("unused")
enum class InteractionMode(override val jsValue: String) : JSEnum {
    Point("point"),
    Dataset("dataset"),
    Index("index"),
    Nearest("nearest"),
}
